import * as _ from 'lodash';
import { GridCell } from '@progress/kendo-react-grid';
import * as React from 'react';
import { SplitButton, MenuItem, ButtonToolbar } from 'react-bootstrap';

import { Formatters } from '../../formatters';

export const ReminderBidActionKeys = {
    viewDetails: 'viewDetails',
    editOrder: 'editOrder',
    createOrder: 'createOrder',
    viewAssociation: 'viewAssociation',
    viewClient: 'viewClient',
    setStatus3YrPendingStart: 'setStatus3YrPendingStart',
    setStatus3YrRenewal: 'setStatus3YrRenewal'
};

export class GridCellDropdownActionsReminderBids extends GridCell {
    public constructor(props: any) {
        super(props);
    }

    public handleButton(e: any, o: any) {
        const { dataItem, field, onChange } = this.props;

        const value = !Formatters.getBool(dataItem, field as string, false);

        if (onChange) {
            onChange({
                dataItem: dataItem,
                field: field,
                syntheticEvent: e.syntheticEvent,
                value: value
            });
        }
    }

    public render() {
        const { dataItem, field, ...rest } = this.props;

        const obj = dataItem[field as string];
        const buttonText = Formatters.getStr(obj, 'text');
        const buttonHref = Formatters.getStr(obj, 'href');
        const buttonTitle = Formatters.getStr(obj, 'title');
        const buttonOrderId = Formatters.getInt(obj, 'orderId');
        const buttonClickHandler = (e: any, k: any, o: any, r: any) => { obj.clickHandler(e, k, o, r); };
        const buttonMenuItems = _.get(obj, 'menuItems', []);

        const className = `k-grid-column-row-dropdown-actions`;

        let buttonProps = {
            bsStyle: 'success',
            bsSize: 'xs',
            disabled: false,
            title: buttonText,
        };

        const splitId = `reminderbid-sb-${buttonOrderId}`;

        //     {
        //         eventKey: ReminderBidActionKeys.viewClient,
        //         text: 'View Client',
        //         id: buttonClientId,
        // associationId: record.associationId,
        //             clientId: record.clientId,
        //             orderId: record.orderId,
        //     },

        const cellInner = (
            <ButtonToolbar>
                <SplitButton {...buttonProps} id={splitId} onClick={(e) => { buttonClickHandler(e, ReminderBidActionKeys.viewDetails, buttonOrderId, undefined); }}>
                    {_.map(buttonMenuItems, (o, i) => (<MenuItem key={`reminderbids-row-splitbutton-id-${o.id}-${i}`} eventKey={o.eventKey} onSelect={(k, e) => { buttonClickHandler(e, k, o.id, o); }}>{o.text}</MenuItem>))}
                </SplitButton>
            </ButtonToolbar>
        );

        return (<td className={className}>{cellInner}</td>);
    }
}



// WEBPACK FOOTER //
// ./src/common/grid/grid-cell-components/gridcell-dropdown-actions-bids-reminders.tsx